import { render, staticRenderFns } from "./eventOrderDetail.vue?vue&type=template&id=9bc2e6c0&scoped=true&"
import script from "./eventOrderDetail.vue?vue&type=script&lang=js&"
export * from "./eventOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./eventOrderDetail.vue?vue&type=style&index=0&id=9bc2e6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc2e6c0",
  null
  
)

export default component.exports